import { useCallback, useEffect, useMemo, useState } from "react";
import PlanHistoryModel from "../../../models/planHistoryModel";
import { findPlans } from "../../../services/planHistoryService";
import { StatusTone } from "../../../components/ui";

export type PlanHistoryRow = PlanHistoryModel & {
  id: string;
  statusLabel: string;
  tone: StatusTone;
};

/** Traduz o `reason` cru da API para um rótulo amigável + tom da StatusBadge. */
const statusFromReason = (reason?: string): { label: string; tone: StatusTone } => {
  const normalized = (reason ?? "").trim().toLowerCase();
  if (normalized.includes("aprovado")) return { label: "Pagamento aprovado", tone: "success" };
  if (normalized.includes("gift")) return { label: "Presente resgatado", tone: "success" };
  if (normalized.includes("cancelado")) return { label: "Plano cancelado", tone: "error" };
  if (normalized.includes("expirou") || normalized.includes("expirad")) return { label: "Plano expirado", tone: "error" };
  return { label: reason || "—", tone: "neutral" };
};

export function usePlanHistory() {
  const [items, setItems] = useState<PlanHistoryModel[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const reload = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await findPlans();
      setItems(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      setError("Não foi possível carregar o histórico de planos.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const rows: PlanHistoryRow[] = useMemo(
    () =>
      items.map((item, index) => {
        const { label, tone } = statusFromReason(item.reason);
        return { ...item, id: String(index), statusLabel: label, tone };
      }),
    [items]
  );

  return { rows, loading, error, reload };
}
